import { useCallback, useState } from 'react';
import { IEntity } from '../../../../../../../types/api/entities/IEntity';
import { Section } from '../types/Section';
import { ComboBoxInputProps } from './useComboBoxInput';
import { useComboBox } from './useComboBox';

export default function useSingleSelectComboBox<T extends IEntity, TResponse>(
  responseMapper: (response: TResponse) => Section<T>[],
  inputProps: Omit<ComboBoxInputProps, 'onInput'>,
  initialValue?: T,
) {
  const [selectedValue, setSelectedValue] = useState<T | undefined>(initialValue);
  const clearSelection = useCallback(() => setSelectedValue(undefined), []);

  const { getComboBoxProps, formInputRef, isValidInputValue } = useComboBox<T, TResponse>(
    responseMapper,
    setSelectedValue,
    {
      ...inputProps,
    },
  );
  return { getComboBoxProps, selectedValue, clearSelection, formInputRef, isValidInputValue };
}
